export function getPsipProtocols() {
	const psipProtocols = ['PSIP-RIV','PSIP-RIF','PSIP-IQF'];
	return psipProtocols;
}
